export const SYNC_SENTIMENTS_SURVEY_COMPLETED = 'COMPLETED';
export const SYNC_SENTIMENTS_SURVEY_ABANDONED = 'ABANDONED';
export const SYNC_SENTIMENTS_SURVEY_CANCELLED = 'CANCELLED';
export const SYNC_SENTIMENTS_SURVEY_BUTTON_SUBMIT = 'OK_BUTTON';
